import React, {useEffect, useState} from 'react';
import _ from "lodash";
import {searchMediasWithSearchCriteria} from "../../services/media-data.service";
import MediaFilters from "./media-filters";
import ShowProgressSpinner from "../../../common/ui/show-progress-spinner";
import ShowEmptyListMessage from "../../../design/components/common/show-empty-list-message";
import {MEDIA_FIELDS_LIST} from "../../constants/media.constant";
import AddEditImageMedia from "../media-editor/add-edit-image-media";

const defaultFilterCriteria: any = {};

const MediaList = () => {
    const [mediasList, setMediasList] = useState(null);
    const [filterCriteria, setFilterCriteria] = useState(defaultFilterCriteria);
    const [dataFetchInProgress, setDataFetchInProgress] = useState(true);

    const getMediaList = async () => {
        setDataFetchInProgress(true);

        const searchCriteriaList = [];

        _.forIn(filterCriteria, (value, attribute) => {
            if ((!_.isEmpty(value) || value === true) && value !== 'EMPTY') {
                searchCriteriaList.push({field: attribute, condition: '==', value: value});
            }
        });

        const mediaListResult = await searchMediasWithSearchCriteria(searchCriteriaList);
        // console.log('mediaListResult', mediaListResult);

        setMediasList(mediaListResult);
        setDataFetchInProgress(false);
    }

    useEffect(() => {
        getMediaList();
    }, [filterCriteria]);

    const refreshMediaList = async () => {
        await getMediaList();
    }

    return (
        <>

            <div className="flex justify-between">

                <div className="flex justify-start items-center mt-2 -ml-2 mb-2 w-full">
                    <div className={'text-xl ml-2'}>
                        Media
                    </div>

                    {/*<MediaFilters
                        filterCriteria={filterCriteria}
                        setFilterCriteria={setFilterCriteria}/>*/}

                    <div className="ml-4">
                        <ShowProgressSpinner dataFetchInProgress={dataFetchInProgress}/>
                    </div>
                </div>

                <div className="text-center w-1/3 flex items-center justify-end">
                    <div className="text-center w-1/6 flex items-center justify-end">
                        <div className="">
                            <button
                                className="button-green-outline px-3 py-1 flex items-center justify-center"
                                onClick={refreshMediaList}>
                                <span>Refresh</span>
                                <span className="ml-1">
                                <ShowProgressSpinner
                                    sizeClass={'w-5 h-5'}
                                    dataFetchInProgress={dataFetchInProgress}/>
                            </span>
                            </button>
                        </div>
                    </div>

                    <div className={'ml-2'}>
                        <AddEditImageMedia isAddImageMedia={true} refreshImageMediaList={refreshMediaList}/>
                    </div>
                </div>

            </div>

            <div className="flex justify-start">

                <div
                    className="w-full bg-white mt-4">

                    <ShowEmptyListMessage
                        dataList={mediasList}
                        dataFetchInProgress={dataFetchInProgress}
                        label={'Media'}/>

                    {mediasList?.length > 0 &&
                        <table className="w-full">
                            <thead className="">
                            <tr>
                                <th className="p-2 border border-gray-400 bg-gray-400 text-white w-12">S.No</th>
                                {MEDIA_FIELDS_LIST?.map((mediaField, rowIndex) => (
                                    <th key={`th-${rowIndex}`}
                                        className={`p-2 border border-gray-400 bg-gray-400 text-white text-left pl-2 ${mediaField?.cssClass}`}>{mediaField?.label}</th>
                                ))}
                                <th className="p-2 border border-gray-400 bg-gray-400 text-white">
                                    Actions
                                </th>
                            </tr>
                            </thead>
                            <tbody className="">
                            {mediasList?.map((media, rowIndex) => (
                                <tr key={`row-${rowIndex}`} className="border border-gray-400">
                                    <td className="p-2 border border-gray-400 m-auto">
                                        <div className="flex justify-center w-12">
                                            {rowIndex + 1}
                                        </div>
                                    </td>

                                    {MEDIA_FIELDS_LIST?.map((mediaField, columnIndex) => (
                                        <React.Fragment key={`column-${rowIndex}-${columnIndex}`}>
                                            <td className={`p-2 border border-gray-400 m-auto ${mediaField?.cssClass}`}>
                                                {mediaField?.optionsMap &&
                                                    <>{mediaField?.optionsMap[media[mediaField?.attribute]]?.name}</>
                                                }

                                                {!mediaField?.optionsMap &&
                                                    <>
                                                        {media[mediaField?.attribute]}

                                                        {mediaField?.secondaryAttribute &&
                                                            <div className={'text-gray-500 text-sm'}>
                                                                {media[mediaField?.secondaryAttribute]}
                                                            </div>
                                                        }
                                                    </>
                                                }
                                            </td>
                                        </React.Fragment>
                                    ))}

                                    <td className="p-2 border border-gray-400 m-auto w-40">
                                        <div className="flex justify-center">
                                            <AddEditImageMedia
                                                isEditImageMedia={true}
                                                selectedImageMedia={media}
                                                refreshImageMediaList={refreshMediaList}/>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    }
                </div>

            </div>

        </>
    )
}

export default MediaList;
